export const noteColors = {
  yellow: 'yellow',
  red: 'red',
  green: 'green',
  blue: 'blue',
};
